

export interface IProductConfiguration {
	readonly version: string;
	readonly commit?: string;

	readonly nameShort: string;
	readonly nameLong: string;
	readonly dataFolderName: string;

	readonly copilotVersions?: {
		readonly runtime: string;
		readonly sdk: string;
	};
	readonly serverDataFolderName?: string;

	readonly defaultChatAgent: IDefaultChatAgent;
}

export interface IDefaultChatAgent {
	readonly extensionId: string;
	readonly chatExtensionId: string;
	readonly completionsEnablementSetting: string;
}
